import { useEffect, useState } from "react";
import "../../Css/Home/HomeSearches.css";
// Import Swiper React components
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/grid"; 
// import required modules
import { Link } from "react-router-dom";
import { get } from "../../services/ApiRouting";
import SectionComp from "../SectionComp";
import venues_demo_image from "../../Images/venues/venues_demo_image.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Pagination } from "swiper/modules";

const HomeSearches = () => {
  const [VenuesList, setVenuesList] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const venuesListFetch = async () => {
    try {
      setLoading(true);
      const response = await get(`categories?page=0&limit=100`);
      setVenuesList(response?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setVenuesList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      venuesListFetch();
    }, 300);

    return () => clearTimeout(dbounce);
  }, []);

  return (
    <>
      <section className="home-search-section section section-bg ">
        <div className="container">
          <div className="home-searches-main-con">
            <SectionComp
              title={"Your Event, Your Way — Choose a Category"}
              para={
                "Discover trusted vendors across all event categories — from venues to entertainment, we've got it all."
              }
            />

            <div className="home-searches-main-details-con">
              {loading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : VenuesList.length > 0 ? (
                <Swiper
                  slidesPerView={1}
                  grid={{
                    rows: 2,
                    fill: 'row'
                  }}
                  spaceBetween={20}
                  pagination={{
                    clickable: true,
                    dynamicBullets: true,
                  }}
                  breakpoints={{
                    640: {
                      slidesPerView: 2,
                      grid: {
                        rows: 2
                      }
                    },
                    768: {
                      slidesPerView: 2,
                      grid: {
                        rows: 2
                      }
                    },
                    1024: {
                      slidesPerView: 3,
                      grid: {
                        rows: 2
                      }
                    },
                    1200: {
                      slidesPerView: 3,
                      grid: {
                        rows: 2
                      }
                    }
                  }}
                  modules={[Grid, Pagination]}
                  className="mySwiper"
                >
                  {VenuesList?.map((elem) => {
                    return (
                      <SwiperSlide key={elem.id} className="d-flex justify-content-center">
                        <div className="home-searches-main-details-card-con mb-3">
                          <Link to={`/vendors?category=${elem.slug}`}>
                            <div className="home-searches-details-con-image-con">
                              <img
                                src={elem.image || venues_demo_image}
                                alt={elem.name}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = venues_demo_image;
                                }}
                              />
                            </div>
                            <div className="home-seraches-image-overlay-text mb-3">
                              <h3> {elem.name} </h3>
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              ) : (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <p>No categories available at the moment.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeSearches;
